import { store } from '@/store/store'
import { CONSTANT, SCOF_AUTH_NTS } from '../../utils/constant.js'
import sharedService from '../../utils/shared-service.js'

const requestBody = {

  authenticationMethodsLookup (srcDigitalCardId, srcCorrelationId, serviceId, authenticationReason) {
    let reqParam = {
      accountReference: {
        srcDigitalCardId: srcDigitalCardId
      },
      authenticationContext: this.getAuthenticationContext(authenticationReason),
      srcCorrelationId: srcCorrelationId,
      serviceId: serviceId,
      srcClientId: store.getters.srcInitiatorIdByNetwork(0),
      ...(store.getters.region === CONSTANT.REGION.IND) && {
        traceId: store.getters.traceId
      }
    }
    return reqParam
  },

  authenticate (authenticationMethods, authenticationReason, srcCorrelationId, srcDigitalCardId, serviceId) {
    let reqParam = {
      authenticationContext: this.getAuthenticationContext(authenticationReason),
      authenticationMethod: authenticationMethods.length > 0 ? authenticationMethods[0] : authenticationMethods,
      srcCorrelationId: srcCorrelationId,
      accountReference: {
        srcDigitalCardId: srcDigitalCardId
      },
      serviceId: serviceId,
      srcClientId: store.getters.srcInitiatorIdByNetwork(0),
      ...(store.getters.region === CONSTANT.REGION.IND) && {
        traceId: store.getters.traceId
      }
    }

    reqParam.authenticationContext.dpaTransactionOptions.dpaLocale = store.getters.scofPreferredLocale
    reqParam.authenticationContext.dpaTransactionOptions.threeDSInputData = { forceChallenge: store.getters.forceChallenge }
    delete reqParam.authenticationMethod.authenticationCredential
    delete reqParam.authenticationMethod.authenticationCredentialReference
    delete reqParam.authenticationMethod.methodAttributes

    return reqParam
  },

  getAuthenticationContext (authenticationReason) {
    let reqParam = {
      dpaTransactionOptions: {
        transactionAmount: {
          transactionAmount: authenticationReason === 'TRANSACTION_AUTHENTICATION' ? store.getters.transactionAmount : 0,
          transactionCurrencyCode: store.getters.currency
        }
      },
      authenticationReasons: [authenticationReason]
    }

    if (authenticationReason === 'TRANSACTION_AUTHENTICATION') {
      let dpaData = this.getSrcDPAData()
      reqParam.dpaData = dpaData
      reqParam.dpaTransactionOptions.merchantCategoryCode = dpaData.merchantCategoryCode
      reqParam.dpaTransactionOptions.merchantCountryCode = dpaData.merchantCountryCode
      reqParam.dpaTransactionOptions.threeDsPreference = store.getters.threeDSPreference ? store.getters.threeDSPreference : 'NONE'
    } else {
      reqParam.srciDpaId = this.getSrcDpaId()
    }

    return reqParam
  },

  bindMFA (selectedMfaEligibilityId, maskedCardData, fidoData = null, isFidoAssertion = false) {
    let reqParam = {
      environmentId: localStorage.getItem('setEnv'),
      region: store.getters.region,
      ...(store.getters.region === CONSTANT.REGION.IND) && {
        srcCxFlowId: store.getters.traceId
      },
      appInstanceId: localStorage.getItem(CONSTANT.APP_INSTANCE_KEY) ? localStorage.getItem(CONSTANT.APP_INSTANCE_KEY) : sharedService.getAppInstanceId(),
      userId: store.getters.consumerInfo.userId,
      bindMfaMethodRequest: {
        srcClientId: store.getters.srcInitiatorIdByNetwork(0),
        serviceId: maskedCardData.serviceId,
        srcDigitalCardId: maskedCardData.srcDigitalCardId,
        mfaMethod: {
          type: store.getters.thirdPartyFIDO ? 'FIDO2' : 'PROPRIETARY',
          certifiedMfaMethodId: selectedMfaEligibilityId,
          ...(store.getters.thirdPartyFIDO) && {
            fidoMfaMethodData: this.getFidoMfaMethodData(isFidoAssertion, fidoData),
            ...(isFidoAssertion) && {
              assertionData: {
                publicKeyCredentials: fidoData
              }
            }
          }
        },
        ...this.getConsumerDeviceData()
      },
      ...this.getThirdPartyFidoParam(isFidoAssertion)
    }

    reqParam = this.setFlowSpecificRequestPram(reqParam, maskedCardData)

    return reqParam
  },

  bindNTS (maskedCardData, sessionAssuranceValue) {
    let reqParam = {
      environmentId: localStorage.getItem('setEnv'),
      region: store.getters.region,
      ...(store.getters.region === CONSTANT.REGION.IND) && {
        srcCxFlowId: store.getters.traceId
      },
      bindMfaMethodRequest: {
        srcClientId: store.getters.srcInitiatorIdByNetwork(0),
        serviceId: maskedCardData.serviceId,
        srcDigitalCardId: maskedCardData.srcDigitalCardId,
        srcCorrelationId: maskedCardData.srcCorrelationId,
        sessionAssuranceValue: sessionAssuranceValue
      }
    }
    return reqParam
  },

  setFlowSpecificRequestPram (reqParam, maskedCardData) {
    let flow = store.getters.scofExecutionFlow
    if (flow === 'TAV') {
      reqParam.iaavEnabled = true
      reqParam.iaav = store.getters.tavInfo
      reqParam.bindMfaMethodRequest.srcCorrelationId = maskedCardData.srcCorrelationId
      return reqParam
    }
    let mdesAuthenticateResponse = store.getters.mdesAuthenticateResponse
    if (flow === 'MDES_IDV' && mdesAuthenticateResponse !== '') {
      reqParam.bindMfaMethodRequest.srcCorrelationId = mdesAuthenticateResponse.authenticateResponse.srcCorrelationId
      reqParam.bindMfaMethodRequest.assuranceData = mdesAuthenticateResponse.authenticateResponse.assuranceData
      return reqParam
    }

    if (flow === 'EXTERNAL_3DS') {
      reqParam.externalThreeDS = true
      reqParam.methodAttributes = store.getters.authResponse.response.methodAttributes
    }

    if (store.getters.authResponse) {
      reqParam.bindMfaMethodRequest.srcCorrelationId = store.getters.authResponse.response.srcCorrelationId
      reqParam.bindMfaMethodRequest.assuranceData = store.getters.authResponse.response.assuranceData
    }
    return reqParam
  },

  getConsumerDeviceData () {
    return {
      ...(store.getters.thirdPartyFIDO) && {
        consumerDeviceData: {
          appInstanceId: localStorage.getItem(CONSTANT.APP_INSTANCE_KEY) ? localStorage.getItem(CONSTANT.APP_INSTANCE_KEY) : sharedService.getAppInstanceId()
        }
      }
    }
  },

  getThirdPartyFidoParam (isFidoAssertion) {
    return {
      ...(isFidoAssertion && store.getters.thirdPartyFIDO) && {
        existingUser: true
      },
      ...(store.getters.thirdPartyFIDO) && {
        thirdPartyFido2: true
      }
    }
  },

  getFidoMfaMethodData (isFidoAssertion, fidoData) {
    return {
      relyingParty: window.location.hostname,
      fidoUserId: store.getters.consumerInfo.userId,
      ...(!isFidoAssertion) && {
        publicKeyCredential: fidoData
      }
    }
  },

  unbindMFA (key, value, srcDigitalCardId, certifiedMfaMethodId, serviceId, srcCorrelationId, additionalKey = null) {
    let paramKey = (key === 'resourceId' && additionalKey ? (additionalKey === 'externalMfaMethodInstanceId' ? 'externalMfaMethodInstanceId' : 'mfaMethodInstanceId') : key)
    return {
      environmentId: localStorage.getItem('setEnv'),
      region: store.getters.region,
      ...(store.getters.region === CONSTANT.REGION.IND) && {
        srcCxFlowId: store.getters.traceId
      },
      appInstanceId: localStorage.getItem(CONSTANT.APP_INSTANCE_KEY) ? localStorage.getItem(CONSTANT.APP_INSTANCE_KEY) : sharedService.getAppInstanceId(),
      userId: store.getters.consumerInfo.userId,
      srcDigitalCardId: srcDigitalCardId,
      unbindMfaMethodRequest: {
        certifiedMfaMethodId: certifiedMfaMethodId,
        srcCorrelationId: srcCorrelationId,
        serviceId: serviceId,
        mfaIdType: (paramKey === 'mfaMethodInstanceId' && !store.getters.thirdPartyFIDO) ? 'INTERNAL' : 'EXTERNAL',
        [paramKey]: value,
        srcClientId: store.getters.srcInitiatorIdByNetwork(0),
        ...(key === 'resourceId') && {
          resourceId: srcDigitalCardId,
          resourceType: 'CARD'
        }
      }
    }
  },

  checkoutWithTransactionAuthentication (maskedCardData, assuranceData = null, srcCorrelationId = null) {
    let reqParam = {
      environmentId: localStorage.getItem('setEnv'),
      region: store.getters.region,
      ...(store.getters.region === CONSTANT.REGION.IND) && {
        srcCxFlowId: store.getters.traceId
      },
      checkoutRequest: {
        serviceId: maskedCardData.serviceId,
        srcDigitalCardId: maskedCardData.srcDigitalCardId,
        srcClientId: store.getters.srcInitiatorIdByNetwork(0),
        srcCorrelationId: srcCorrelationId,
        srcDpaId: this.getSrcDpaId(),
        dpaTransactionOptions: {
          transactionAmount: {
            transactionAmount: Number(store.getters.totalPrice.toFixed(2)),
            transactionCurrencyCode: store.getters.currency
          }
        }
      },
      mfaMethod: {
        type: 'PROPRIETARY'
      }
    }
    if (store.getters.enableNativeIntegrationFlow === true && assuranceData !== null) {
      reqParam.checkoutRequest.assuranceData = assuranceData
    }
    if (sharedService.checkFeatureFlag('START_NTS_CHANGES') && store.getters.enableNativeIntegrationFlow) {
      reqParam.flowType = SCOF_AUTH_NTS
    }
    return reqParam
  },

  scofPayload (selectedMfaEligibilityId, bindMfaInstanceId, maskedCardData, assuranceData, srcCorrelationId = null, keyName) {
    let reqParam = {
      environmentId: localStorage.getItem('setEnv'),
      region: store.getters.region,
      ...(store.getters.region === CONSTANT.REGION.IND) && {
        srcCxFlowId: store.getters.traceId
      },
      checkoutRequest: {
        serviceId: maskedCardData.serviceId,
        srcDigitalCardId: maskedCardData.srcDigitalCardId,
        srcClientId: store.getters.srcInitiatorIdByNetwork(0),
        srcCorrelationId: maskedCardData.srcCorrelationId ? maskedCardData.srcCorrelationId : srcCorrelationId,
        srcDpaId: this.getSrcDpaId(),
        dpaTransactionOptions: {
          transactionAmount: {
            transactionAmount: Number(store.getters.totalPrice.toFixed(2)),
            transactionCurrencyCode: store.getters.currency
          }
        }
      },
      mfaMethod: {
        type: store.getters.thirdPartyFIDO ? 'FIDO2' : 'PROPRIETARY',
        certifiedMfaMethodId: selectedMfaEligibilityId,
        [keyName]: bindMfaInstanceId
      }
    }
    if (bindMfaInstanceId === '' && !store.getters.thirdPartyFIDO) {
      delete reqParam.mfaMethod
    }

    if (store.getters.thirdPartyFIDO) {
      delete reqParam.mfaMethod.mfaMethodInstanceId
      reqParam.mfaMethod['externalMfaMethodInstanceId'] = store.getters.deviceExternalMfaMethodInstanceId
    }

    let flow = store.getters.scofExecutionFlow

    if (flow === 'TXAV' || store.getters.thirdPartyFIDO) {
      reqParam.checkoutRequest.assuranceData = assuranceData
    }
    if (store.getters.authResponse.selectedMethod === 'MANAGED_AUTHENTICATION') {
      reqParam.checkoutRequest.assuranceData = store.getters.authResponse.response.assuranceData
    }
    return reqParam
  },

  b2bAuthLookup (authenticationReason, srcCorrelationId, srcDigitalCardId) {
    let reqParam = {
      environmentId: localStorage.getItem('setEnv'),
      ...(store.getters.region === CONSTANT.REGION.IND) && {
        srcCxFlowId: store.getters.traceId
      },
      region: store.getters.region,
      srcDpaId: store.getters.scofDpaId,
      b2BLookupAuthenticationRequest: {
        srcClientId: store.getters.srcInitiatorIdByNetwork(0),
        srcCorrelationId: srcCorrelationId,
        accountReference: {
          srcDigitalCardId: srcDigitalCardId
        },
        authenticationContext: {
          authenticationReasons: [authenticationReason]
        }
      }
    }
    return reqParam
  },

  saveCard (startAccessJwt, maskedCardDetails, certifiedMfaMethodId, mfaMethodInstanceId, externalMfaMethodInstanceId) {
    const {
      srcDigitalCardId,
      panLastFour,
      digitalCardData: { artUri, descriptorName },
      panExpirationMonth,
      panExpirationYear,
      serviceId
    } = maskedCardDetails

    const maskedCard = {
      srcDigitalCardId,
      panLastFour,
      digitalCardData: {
        artUri,
        descriptorName
      },
      panExpirationMonth,
      panExpirationYear,
      serviceId
    }
    let reqData = {
      region: store.getters.region,
      ...(store.getters.region === CONSTANT.REGION.IND) && {
        srcCxFlowId: store.getters.traceId
      },
      environmentId: localStorage.getItem('setEnv'),
      appInstanceId: localStorage.getItem(CONSTANT.APP_INSTANCE_KEY) ? localStorage.getItem(CONSTANT.APP_INSTANCE_KEY) : sharedService.getAppInstanceId(),
      certifiedMfaMethodId: certifiedMfaMethodId,
      mfaMethodInstanceId: mfaMethodInstanceId,
      externalMfaMethodInstanceId: externalMfaMethodInstanceId,
      checkoutRequest: {
        serviceId: store.getters.enrollMaskCard.serviceId,
        srcDigitalCardId: store.getters.enrollMaskCard.srcDigitalCardId,
        srcClientId: store.getters.srcInitiatorIdByNetwork(0),
        srcCorrelationId: store.getters.enrollMaskCard.srcCorrelationId,
        srcDpaId: store.getters.scofDpaId,
        dpaTransactionOptions: {
          transactionAmount: {
            transactionAmount: store.getters.authResponse ? ((store.getters.authResponse.authReason === 'TRANSACTION_AUTHENTICATION') ? Number(store.getters.totalPrice.toFixed(2)) : 0) : 0,
            transactionCurrencyCode: store.getters.currency
          }
        }
      },
      startAccessJwt,
      maskedCard
    }
    return reqData
  },

  b2bMDESInitiateAuthenticate (authenticationMethod, authenticationReason, srcCorrelationId, srcDigitalCardId, serviceId) {
    let reqParam = {
      environmentId: localStorage.getItem('setEnv'),
      region: store.getters.region,
      ...(store.getters.region === CONSTANT.REGION.IND) && {
        srcCxFlowId: store.getters.traceId
      },
      authenticateRequest: {
        srcCorrelationId: srcCorrelationId,
        accountReference: {
          srcDigitalCardId: srcDigitalCardId
        },
        serviceId: serviceId,
        srcClientId: store.getters.srcInitiatorIdByNetwork(0),
        authenticationContext: {
          authenticationReasons: [authenticationReason]
        },
        authenticationMethod: {
          authenticationMethodType: authenticationMethod.authenticationMethodType,
          authenticationSubject: authenticationMethod.authenticationSubject,
          authenticationCredentialReference: authenticationMethod.authenticationCredentialReference
        }

      }
    }
    return reqParam
  },

  b2bMDESCompleteAuthenticate (authenticationMethod, authenticationSessionId, srcCorrelationId, srcDigitalCardId, serviceId, otpValue) {
    let reqParam = {
      environmentId: localStorage.getItem('setEnv'),
      region: store.getters.region,
      ...(store.getters.region === CONSTANT.REGION.IND) && {
        srcCxFlowId: store.getters.traceId
      },
      authenticateRequest: {
        srcCorrelationId: srcCorrelationId,
        accountReference: {
          srcDigitalCardId: srcDigitalCardId
        },
        serviceId: serviceId,
        srcClientId: store.getters.srcInitiatorIdByNetwork(0),
        authenticationSessionId: authenticationSessionId,
        authenticationMethod: {
          authenticationMethodType: authenticationMethod.authenticationMethodType,
          authenticationSubject: authenticationMethod.authenticationSubject,
          methodAttributes: {
            otpValue: otpValue
          }
        }
      }
    }
    return reqParam
  },

  b2bAuthenticateWithAssertion (srcCorrelationId, srcDigitalCardId, serviceId, assertion, certifiedMfaMethodId, BindMfaMethodInstanceId, keyName) {
    return {
      environmentId: store.getters.environment,
      region: store.getters.region,
      ...(store.getters.region === CONSTANT.REGION.IND) && {
        srcCxFlowId: store.getters.traceId
      },
      iaavEnabled: false,
      ...(sharedService.checkFeatureFlag('START_SPL_CHANGES')) && {
        authenticationFactors: store.getters.authenticationFactors
      },
      authenticateRequest: {
        srcCorrelationId: srcCorrelationId,
        accountReference: {
          srcDigitalCardId: srcDigitalCardId
        },
        serviceId: serviceId,
        srcClientId: store.getters.srcInitiatorIdByNetwork(0),
        authenticationContext: {
          authenticationReasons: [
            'TRANSACTION_AUTHENTICATION'
          ],
          dpaTransactionOptions: {
            transactionAmount: {
              transactionAmount: store.getters.transactionAmount,
              transactionCurrencyCode: store.getters.currency
            }
          },
          ...this.getConsumerDeviceData()
        },
        authenticationMethod: {
          authenticationMethodType: 'FIDO2',
          authenticationSubject: 'CARDHOLDER',
          methodAttributes: {
            boundMfaMethod: {
              mfaMethod: {
                type: 'FIDO2',
                certifiedMfaMethodId: certifiedMfaMethodId,
                [keyName]: BindMfaMethodInstanceId || store.getters.deviceExternalMfaMethodInstanceId,
                fidoMfaMethodData: { ...this.getFidoMfaMethodData(true, assertion), isSpcEnabled: false },
                assertionData: {
                  publicKeyCredentials: assertion
                }
              }
            }
          }
        }
      }
    }
  },

  b2bNTSAuthenticateRegister (srcCorrelationId, srcDigitalCardId, serviceId) {
    return {
      environmentId: store.getters.environment,
      region: store.getters.region,
      authenticateRequest: {
        srcCorrelationId: srcCorrelationId,
        accountReference: {
          srcDigitalCardId: srcDigitalCardId
        },
        serviceId: serviceId,
        srcClientId: store.getters.srcInitiatorIdByNetwork(0),
        authenticationContext: {
          authenticationReasons: [
            'AUTHENTICATOR_REGISTRATION'
          ],
          callbackUri: {
            uri: `${window.location.origin}/auth-process`,
            uriType: 'WEB_URI'
          },
          dpaTransactionOptions: {
            dpaLocale: store.getters.scofPreferredLocale,
            transactionAmount: {
              transactionAmount: 0,
              transactionCurrencyCode: store.getters.currency
            }
          },
          consumerDeviceData: {
            appInstanceId: localStorage.getItem(CONSTANT.APP_INSTANCE_KEY) ? localStorage.getItem(CONSTANT.APP_INSTANCE_KEY) : sharedService.getAppInstanceId()
          }
        },
        authenticationMethod: {
          authenticationMethodType: 'FIDO2',
          authenticationSubject: 'CARDHOLDER'
        },
        assuranceData: store.getters.mdesAuthenticateResponse.authenticateResponse.assuranceData
      }
    }
  },

  b2bNTSTransactionAuthentication (srcCorrelationId, srcDigitalCardId, serviceId) {
    const region = store.getters.region
    const authDpaDataKey = region === CONSTANT.REGION.GLOBAL ? store.getters.environment : (store.getters.environment).concat('_', region)
    return {
      environmentId: store.getters.environment,
      region: store.getters.region,
      authenticateRequest: {
        srcCorrelationId: srcCorrelationId,
        accountReference: {
          srcDigitalCardId: srcDigitalCardId
        },
        serviceId: serviceId,
        srcClientId: store.getters.srcInitiatorIdByNetwork(0),
        authenticationContext: {
          authenticationReasons: [
            'TRANSACTION_AUTHENTICATION'
          ],
          callbackUri: {
            uri: `${window.location.origin}/auth-process`,
            uriType: 'WEB_URI'
          },
          dpaTransactionOptions: {
            transactionAmount: {
              transactionAmount: Number(store.getters.totalPrice.toFixed(2)),
              transactionCurrencyCode: store.getters.currency
            }
          },
          acquirerMerchantId: store.getters.authDpaData[authDpaDataKey].acquirerId,
          acquirerBIN: store.getters.authDpaData[authDpaDataKey].acquirerBin,
          consumerDeviceData: {
            appInstanceId: localStorage.getItem(CONSTANT.APP_INSTANCE_KEY) ? localStorage.getItem(CONSTANT.APP_INSTANCE_KEY) : sharedService.getAppInstanceId()
          }
        },
        authenticationMethod: {
          authenticationMethodType: 'FIDO2',
          authenticationSubject: 'CARDHOLDER'
        }
      }
    }
  },

  generatetav (encryptedCard, txID, flow) {
    let reqParam = {
      environmentId: localStorage.getItem('setEnv'),
      region: store.getters.region,
      srciClientId: store.getters.srcInitiatorIdByNetwork(0),
      encryptedCard: encryptedCard,
      tavRequest: {
        version: 4
      }
    }

    if (flow === 'TXAV') {
      delete reqParam.tavRequest
      reqParam.txavRequest = {
        txID: txID,
        txAmount: Number(store.getters.totalPrice.toFixed(2)),
        txCurrencyCode: store.getters.currency
      }
    }
    return reqParam
  },

  authenticateForTxav (maskedCard) {
    let reqParam = {
      environmentId: localStorage.getItem('setEnv'),
      region: store.getters.region,
      ...(store.getters.region === CONSTANT.REGION.IND) && {
        srcCxFlowId: store.getters.traceId
      },
      iaavEnabled: true,
      iaav: store.getters.tavInfo,
      authenticateRequest: {
        srcClientId: store.getters.srcInitiatorIdByNetwork(0),
        serviceId: maskedCard.serviceId,
        srcCorrelationId: maskedCard.srcCorrelationId,
        srciTransactionId: maskedCard.srcCorrelationId,
        accountReference: {
          srcDigitalCardId: maskedCard.srcDigitalCardId
        },
        authenticationContext: {
          authenticationReasons: ['TRANSACTION_AUTHENTICATION'],
          dpaTransactionOptions: {
            transactionAmount: {
              transactionAmount: Number(store.getters.totalPrice.toFixed(2)),
              transactionCurrencyCode: store.getters.currency
            }
          }
        },
        authenticationMethod: {
          authenticationMethodType: 'IAAV',
          authenticationSubject: 'CARDHOLDER'
        }
      }
    }
    return reqParam
  },

  getDecodedAuthSessionId (authResponse) {
    let authResponseString =
      authResponse.response.assuranceData.verificationData[0].additionalData || ''
    let encodedString = authResponseString.split('.')[1]
    let decodedAuthResponse = JSON.parse(atob(encodedString))
    let authSessionId = JSON.parse(
      decodedAuthResponse.scopeData
    ).authSessionId
    return authSessionId
  },

  getSrcDpaId () {
    let dpaDetails = store.getters.dpaIds.filter((dpa) => dpa['displayDpaName'].includes('COF'))[0]
    return dpaDetails.dpa[0].dpaId
  },

  getSrcDPAData () {
    let dpaDetail = store.getters.dpaIds.filter((dpa) => dpa['displayDpaName'].includes('COF'))[0].dpa[0]
    let authDpaData = store.getters.authDpaData
    const region = store.getters.region
    const authDpaDataKey = region === CONSTANT.REGION.GLOBAL ? store.getters.environment : (store.getters.environment).concat('_', region)
    return {
      dpaName: dpaDetail.legalName,
      dpaPresentationName: dpaDetail.presentationName,
      acquirerId: authDpaData[authDpaDataKey].acquirerId,
      acquirerBin: authDpaData[authDpaDataKey].acquirerBin,
      merchantCategoryCode: authDpaData[authDpaDataKey].merchantCategoryCode,
      merchantCountryCode: authDpaData[authDpaDataKey].merchantCountryCode
    }
  },

  b2bResult (maskedCardData, sessionAssuranceValue) {
    let reqParam = {
      environmentId: localStorage.getItem('setEnv'),
      region: store.getters.region,
      ...(store.getters.region === CONSTANT.REGION.IND) && {
        srcCxFlowId: store.getters.traceId
      },
      authenticationsResultsRequest: {
        srcClientId: store.getters.srcInitiatorIdByNetwork(0),
        serviceId: maskedCardData.maskedCard.serviceId,
        srcDigitalCardId: maskedCardData.maskedCard.srcDigitalCardId,
        srcCorrelationId: maskedCardData.srcCorrelationId,
        sessionAssuranceValue: sessionAssuranceValue
      }
    }
    return reqParam
  }

}

export default requestBody
